import React from 'react';
import { TIMELINE, CREDENTIALS, IMAGES } from '../mock';

export default function Timeline() {
  return (
    <section id="response" className="relative py-28 md:py-36 bg-[var(--bg-alt)] border-y border-[var(--line)]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="grid lg:grid-cols-2 gap-10 items-end">
          <div data-reveal>
            <div className="label-mono text-[var(--accent)] mb-6">Response Timeline</div>
            <h2 className="font-display text-[clamp(2.2rem,5.5vw,4.2rem)] text-white">
              Ninety minutes,<br />
              <span className="font-display-italic text-[#c3cbdb]">start to cold.</span>
            </h2>
          </div>
          <p className="text-[var(--muted)] text-[15px] leading-relaxed max-w-lg" data-reveal data-delay="80">
            An emergency doesn’t need a portal or a ticket. It needs an engineer in a van, with the right gauge set, on the pavement outside your door. That’s the whole business.
          </p>
        </div>

        {/* Timeline cards */}
        <div className="mt-20 grid md:grid-cols-2 lg:grid-cols-4 gap-y-14 gap-x-8">
          {TIMELINE.map((t, i) => (
            <div key={t.num} className="relative" data-reveal data-delay={i * 70}>
              <div className="flex items-center justify-between border-t border-[var(--line-strong)] pt-4">
                <span className="label-mono text-[var(--accent)]">{t.time}</span>
                <span className="font-display text-[2.4rem] text-white/12 leading-none">{t.num}</span>
              </div>
              <h4 className="font-display text-[1.35rem] text-white mt-8">{t.title}</h4>
              <p className="mt-4 text-[13px] text-[var(--muted)] leading-relaxed">{t.body}</p>
            </div>
          ))}
        </div>

        {/* Credentials block */}
        <div className="mt-28 grid lg:grid-cols-2 gap-10 items-stretch">
          <div className="relative border border-[var(--line)] overflow-hidden min-h-[340px]" data-reveal>
            <img src={IMAGES.circuit} alt="Engineer inspecting a printed circuit board" className="w-full h-full object-cover absolute inset-0" />
            <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg,rgba(9,12,19,0.2),rgba(9,12,19,0.7))' }} />
            <span className="absolute top-4 left-4 label-mono text-white/85 flex items-center gap-2"><span className="w-1.5 h-1.5 bg-[var(--accent)]" /> Field · Diagnostic</span>
          </div>
          <div className="flex flex-col justify-center" data-reveal data-delay="90">
            <div className="label-mono text-[var(--accent)] mb-8">Credentials</div>
            <ul className="flex flex-col">
              {CREDENTIALS.map((c, i) => (
                <li key={i} className="flex items-start gap-4 py-5 border-t border-[var(--line)] last:border-b">
                  <span className="font-mono text-[var(--accent)] text-sm mt-0.5">/*</span>
                  <span className="text-[15px] text-[#c3cbdb]">{c}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
